'use client';

import { DATADOG_RUM_NAME, useConsent } from '@lichtblick/consent';
import { useEffect } from 'react';

export const RUMTracking = ({ viewName }: { viewName: string }) => {
  const datadogRumState = useConsent(DATADOG_RUM_NAME);

  useEffect(() => {
    if (datadogRumState) {
      import('@datadog/browser-rum').then(({ datadogRum }) => {
        datadogRum.onReady(() => {
          datadogRum.startView({
            name: `${viewName}`,
            service: process.env.NEXT_PUBLIC_DATADOG_SERVICE_NAME,
            version: process.env.NEXT_PUBLIC_VERSION,
          });

          datadogRum.startSessionReplayRecording();
        });
      });
    }
  }, [datadogRumState, viewName]);

  return null;
};
